<template>
  <dashboard-chart-card
    title="Resumen de nuevos tickets por día"
    @handleDownloadClick="$emit('handleDownload')"
  >
    <template #info>
      <a-popover
        trigger="hover"
        class="popover"
        placement="bottomRight"
        :overlayStyle="{ width: '250px' }"
      >
        <template #title>
          <span class="titlePopover"> Nuevos tickets </span>
        </template>
        <template #content>
          <div class="content">
            Visualiza y descarga el detalle de los tickets nuevos generados en la plataforma.
            <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer">Click aquí</a>
            si quieres saber que son los tickets en {{ ProductName }}.
          </div>
        </template>
        <InfoCircleOutlined class="info-circle" />
      </a-popover>
    </template>

    <div>
      <AreaDateChartSummary :data="chartData" />
    </div>
  </dashboard-chart-card>
</template>

<script>
import { defineComponent } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import dayjs from "dayjs";

import { groupBy } from "@/app/dashboard/utils/groupBy";
import { dateTimeToSlashFormat } from "@/app/shared/utils/dates";
import { ProductName } from "@/app/shared/utils/constants";

import AreaDateChartSummary from "@/app/dashboard/components/charts/AreaDateChartSummary.vue";
import DashboardChartCard from "../cards/DashboardChartCard.vue";

export default defineComponent({
  components: {
    DashboardChartCard,
    AreaDateChartSummary,
    InfoCircleOutlined,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    hourRange: {
      required: true,
      type: Object,
    },
  },
  computed: {
    chartData() {
      if (!this.data?.tickets_summary) return [];

      const hasHourRange = Object.values(this.hourRange).length !== 0;
      const isDateFormat = (date) => dayjs(date, "YYYY-MM-DD", true).isValid();

      const dataGrouped = groupBy(this.data?.tickets_summary, (ticket) =>
        isDateFormat(ticket?.date) ? ticket?.date : dayjs(ticket?.date).hour()
      );

      const chartData = [];

      for (const key in hasHourRange ? this.hourRange : dataGrouped) {
        const data = {};

        data.date = key;
        data.count = dataGrouped[key]?.reduce((prev, curr) => prev + curr?.count, 0) || 0;

        chartData.push(data);
      }

      const sorter = (a, b) => {
        return new Date(a.date) - new Date(b.date);
      };

      chartData.sort(sorter);

      return chartData.map((axisData) =>
        axisData?.date?.length > 2
          ? { ...axisData, date: dateTimeToSlashFormat(axisData.date, false) }
          : { hour: axisData.date, count: axisData.count }
      );
    },
  },
  data() {
    const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/dashboards/resumen-tickets-nuevos-dia/`;
    return {
      DOCS_URL: DOCS_URL,
      ProductName,
    };
  },
});
</script>

<style lang="sass" scoped>
:deep(.ant-select)
  width: 280px

.queue__width
  width: 150px

.margin-botton
  margin-bottom: 2px
  color: $gray-8

.popover
  margin-right: 20px

.info-circle
  font-size: 14px
  color: #51555A

.content
  font-weight: 300
  color: $gray-8

.titlePopover
  font-size: 16px
  font-weight: 600
</style>
